import { useCallback, useEffect, useState } from 'react'
import { api } from '@/lib/api.ts'
import type { Story } from '@/lib/types.ts'

/** Fetches a fresh handful of stories on mount, and on demand. */
export function useNews() {
  const [stories, setStories] = useState<Story[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const load = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      setStories((await api.news()).stories)
    } catch {
      setError('The stories could not be gathered just now.')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => { void load() }, [load])

  return { stories, loading, error, reload: load }
}
